<script lang="ts" setup>
import { PageError } from '@brighterly/lib-lumee-ui'

import type { NuxtError } from '#app'

import amplitudeConfig from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

defineOptions({
  name: 'PageError',
})

const props = defineProps<{
  error: NuxtError
}>()

trackEvent(amplitudeConfig.events.pageNotFound, {
  error: String(props.error),
})

const goHome = (): Promise<void> => clearError({ redirect: '/' })

</script>

<template>
  <main>
    <PageError @cta="goHome" />
  </main>
</template>
